import { RouterModule, Routes } from '@angular/router';
import { IncidentMapComponent } from './incident-map.component';

const routes: Routes = [
	{ path: '', component: IncidentMapComponent },
];


export const incidentRoutes = RouterModule.forChild(routes);